import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion'; // Importar Framer Motion

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  console.log(API_BASE_URL);
  const { t } = useTranslation('login');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError(t('errors.complete_all_fields'));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(t('errors.invalid_email'));
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}auth/login`, {
        email,
        password,
      });

      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      window.location.href = '/';
    } catch (err) {
      setError(err.response?.data?.error || t('errors.login_failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledWrapper>
      <motion.div
        className="login-container"
        initial={{ opacity: 0, scale: 0.8 }} // Animación inicial
        animate={{ opacity: 1, scale: 1 }} // Animación al cargar
        transition={{ duration: 0.5, ease: 'easeOut' }} // Duración y estilo de la transición
      >
        <motion.h2
          className="title"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          {t('title')}
        </motion.h2>
        <motion.form
          className="form"
          onSubmit={handleSubmit}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <motion.input
            type="email"
            placeholder={t('placeholders.email')}
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            whileFocus={{ scale: 1.05, borderColor: '#00bcd4' }} // Efecto al enfocar
          />
          <motion.input
            type="password"
            placeholder={t('placeholders.password')}
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            whileFocus={{ scale: 1.05, borderColor: '#00bcd4' }} // Efecto al enfocar
          />
          {error && (
            <motion.p
              className="error-message"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
            >
              {error}
            </motion.p>
          )}
          <motion.button
            className="form-btn"
            type="submit"
            disabled={loading}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {loading ? t('loading') : t('buttons.login')}
          </motion.button>
        </motion.form>
        <motion.p
          className="page-link"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <span className="page-link-label">{t('forgot_password')}</span>
        </motion.p>
      </motion.div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;

  .login-container {
    width: 350px;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
    border-radius: 10px;
    padding: 20px 30px;
  }

  .title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .input {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
    font-size: 16px;
    transition: border-color 0.3s ease;
  }

  .form-btn {
    padding: 10px;
    background-color: teal;
    color: white;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .form-btn:disabled {
    background-color: gray;
    cursor: not-allowed;
  }

  .form-btn:hover:not(:disabled) {
    background-color: darkcyan;
  }

  .page-link {
    margin-top: 10px;
    text-align: center;
  }

  .page-link-label {
    color: teal;
    cursor: pointer;
    text-decoration: underline;
    font-size: 14px;
  }

  .page-link-label:hover {
    color: darkcyan;
  }

  .error-message {
    color: red;
    font-size: 14px;
    text-align: center;
  }
`;

export default Login;